import {
  selectChecklistCompletedSteps,
  UpdateChecklistCompletedSteps,
} from '../../../store/slices/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

export function useUpdateChecklistCompletedStepsByKey() {
  const dispatch = useAppDispatch();
  const completedSteps = useAppSelector(selectChecklistCompletedSteps);

  const updateStepByKey = (
    key: string,
  ) => {
    if (!completedSteps.includes(key)) {
      dispatch(UpdateChecklistCompletedSteps(key));
    }
  };
  return updateStepByKey;
}
